import { isNull, find } from "lodash";

const getCurrentMapPosition = (
  currentFilters,
  currentMapPosition,
  data,
  initMapPosition
) => {
  if (!isNull(currentFilters)) {
    let lastSelected = Object.keys(currentFilters);
    lastSelected = lastSelected[lastSelected.length - 1];
    if (lastSelected === "divisions") {
      let result = find(
        data.countries,
        o => o.division === currentFilters.divisions
      );

      return result.divisionCords;
    } else {
      for (let place of data.countries) {
        if (currentFilters.countries === place.country) {
          return {
            geoCords: {
              lat: parseInt(place.geoCords.lat),
              lng: parseInt(place.geoCords.lng)
            },
            zoom: 6
          };
        }
      }
      return currentMapPosition;
    }/* else if (lastSelected === "countries") {
      for (let place of data.countries) {
        if (currentFilters.countries === place.country) {
          return {
            geoCords: {
              lat: parseInt(place.geoCords.lat),
              lng: parseInt(place.geoCords.lng)
            },
            zoom: 6
          };
        }
      }
    } else {
      return currentMapPosition;
    }*/
  } else {
    return initMapPosition;
  }
};
export default getCurrentMapPosition;
